import ViewController from "core/views/view.controller";
import Moment from "moment/moment";
import {Item, Items} from "core/model/items.model";

export default class NewBookingDurationCtrl extends ViewController {
    static $inject = ['$scope', '$state', '$ionicHistory'];

    constructor() {
        super(...arguments);

        this.booking = null;
        this.duration = null;
        this.totalDuration = null;
        this.maxDuration = null;
    }

    $onViewBeforeEnter() {
        this.loadBookingState();
        this.loadDuration();
    }

    prev() {
        this.saveBookingState();
        this.$ionicHistory.goBack();
    }

    next() {
        if (this.booking <= 0) {
            return;
        }

        this.saveBookingState();
        this.toState('tab.new-booking-resource');
    }

    loadBookingState() {
        this.booking = this.viewState('booking');
        this.duration = this.booking.duration;
    }

    loadDuration() {
        if (this.booking.services && this.booking.services.length > 0) {
            this.totalDuration = this.booking.services.reduce((duration, service)=> {
                return duration + service.duration;
            }, 0);
        } else {
            this.totalDuration = 15;
        }

        if (!this.duration) {
            this.duration = this.totalDuration;
        }

        this.maxDuration = Moment().endOf('day').diff(Moment(), 'minutes');
        this.maxDuration = Math.floor(this.maxDuration / 10) * 10;
    }

    saveBookingState() {
        if (this.duration) {
            this.booking.duration = this.duration;
        }

        this.viewState('booking', this.booking);
    }

    resetDuration() {
        this.duration = this.totalDuration;
    }
}



// WEBPACK FOOTER //
// ./src/modules/main/views/new-booking-duration/new-booking-duration.controller.js